var _style, _defs, _path, _g, _g2, _g3, _path2, _path3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApacheCordova(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".G{color-interpolation-filters:sRGB}.H{fill-rule:evenodd}.I{stroke:#d6d6d6}.J{stroke-linejoin:round}.K{stroke-width:.918}.L{stroke-width:.954}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#N",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24303a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#N",
    id: "B",
    x1: 371.822,
    x2: 55.227,
    y1: 391.787,
    y2: 187.815
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#A",
    id: "F",
    x1: 327.184,
    x2: 311.598,
    y1: 311.239,
    y2: 126.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#A",
    id: "G",
    x1: 135.705,
    x2: 151.291,
    y1: 311.239,
    y2: 126.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#N",
    id: "H",
    x1: 352.926,
    x2: 92.151,
    y1: 107.19,
    y2: 133.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#N",
    id: "I",
    x1: 182.228,
    x2: 182.228,
    y1: 190.194,
    y2: 317.94
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#N",
    id: "J",
    x1: 193.994,
    x2: 193.994,
    y1: 190.194,
    y2: 126.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "C",
    width: 1.402,
    height: 1.107,
    x: -0.201,
    y: -0.054,
    className: "G"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11
  })), /*#__PURE__*/React.createElement("filter", {
    id: "D",
    width: 1.83,
    height: 1.222,
    x: -0.415,
    y: -0.111,
    className: "G"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.293
  })), /*#__PURE__*/React.createElement("filter", {
    id: "K",
    width: 1.262,
    height: 1.715,
    x: -0.131,
    y: -0.358,
    className: "G"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.201
  })), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "m508.536-355.138-29.184 76.05h13.74l7.136-20.13h30.356l7.136 20.13h14.272l-29.3-76.05zm-4.686 45.8 11.503-32.7h.32l11.397 32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M562.557-223.477c0 4.18.564 8.254 1.692 12.328s2.932 7.61 5.414 10.827 5.64 5.68 9.474 7.61 8.346 2.894 13.76 2.894c5.3 0 9.812-.965 13.647-2.894s6.88-4.395 9.36-7.61 4.286-6.753 5.414-10.827 1.692-8.147 1.805-12.328c0-4.18-.677-8.254-1.805-12.328-1.128-3.966-2.932-7.504-5.414-10.72s-5.527-5.79-9.36-7.718-8.346-2.894-13.647-2.894c-5.414 0-9.925.965-13.76 2.894s-6.993 4.502-9.474 7.718-4.286 6.753-5.414 10.72a45.8 45.8 0 0 0-1.692 12.328zm-7.67 0c0-5.253.8-10.29 2.37-15.115 1.58-4.717 3.948-9.005 7.106-12.65 3.045-3.645 7.106-6.646 11.843-8.8s10.376-3.216 16.693-3.323c6.316 0 11.843 1.18 16.58 3.323s8.685 5.145 11.843 8.8 5.527 7.933 7.106 12.65c1.58 4.824 2.37 9.862 2.37 15.115 0 5.36-.8 10.398-2.37 15.115-1.58 4.824-3.948 9.005-7.106 12.65s-7.106 6.646-11.843 8.8-10.264 3.216-16.58 3.216-11.955-1.072-16.693-3.216-8.685-5.145-11.843-8.8-5.527-7.825-7.106-12.65c-1.58-4.717-2.37-9.755-2.37-15.115z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#N",
    id: "E",
    cx: 355.75,
    cy: -334.763,
    r: 16.25,
    fx: 355.75,
    fy: -334.763,
    gradientTransform: "matrix(.92308 -11.5077 -5.89644 -.47304 -2165.7 4248.202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25303b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25303b",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.57,
    d: "m407.2 433.212-80.56-128.86h-191.5L54.985 433.194z",
    className: "H",
    filter: "url(#K)",
    transform: "matrix(.07324 0 0 .06489 9.276 17.573)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "H"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7f8082",
    d: "m36.582 38.575-2.18 4.553-1.499-5.669zm-20.066 0L18 43.128l1.5-5.669z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "m54.985 190.194-.012.018 32.8 207.807h56.373l-4.605-48.268h28.924l3.684 48.268h118.1l3.684-48.268h28.74l-4.605 48.268h56.74L407.2 190.194H54.985z",
    className: "I J",
    transform: "matrix(.09432 0 0 .09432 4.405 5.588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "m135.558 317.94 16.956-63.528-1.192-128.3-31.8 64.093z",
    transform: "matrix(.09432 0 0 .09432 4.405 5.588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293441",
    d: "M28.676 16.296h6.628l-.137 14.649h-7.003zm-4.794.01-6.456.003.153 14.584h6.573z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d3948",
    d: "m18.094 29.582-.903 5.992h18.074l-1.076-5.949z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "m327.184 317.94-16.64-63.077.625-129.17 32.195 64.496z",
    transform: "matrix(.09432 0 0 .09432 4.405 5.588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "m135.705 317.94 16.8-63.53-1.192-128.3-31.797 64.1z",
    transform: "matrix(.09432 0 0 .09432 4.405 5.588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d3b48",
    d: "m23.204 19.682.597 12.721h4.648l.75-12.721z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M407.2 190.194 326.65 61.35h-191.5L54.985 190.194h64.54l31.625-63.844h52l-3.835 23.077h63.55l-3.36-23.776H311.3l32.06 64.543z",
    className: "I J",
    transform: "matrix(.09432 0 0 .09432 4.405 5.588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363f49",
    d: "m28.881 17.439 4.927.004 2.982 6.083-1.526 12.05H23.801l5.925-12.05z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M268.465 190.194 205.643 317.94H135.56l-16.035-127.745z",
    opacity: 0.3,
    transform: "matrix(.09432 0 0 .09432 4.405 5.588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M151.15 126.35h52l-3.835 23.077h63.55l5.598 40.767h-148.94z",
    opacity: 0.2,
    transform: "matrix(.09432 0 0 .09432 4.405 5.588)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.08488 0 0 .09222 2.864 58.7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.593,
    cy: -325.399,
    fill: "#05f0ff",
    filter: "url(#D)",
    opacity: 0.8,
    rx: 6.63,
    ry: 24.805,
    transform: "matrix(1.49929 0 0 1.30774 -75.689 99.471)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#06effe",
    filter: "url(#C)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.158,
    cy: -326.054,
    fill: "#fff",
    className: "K",
    opacity: 0.9,
    rx: 6.63,
    ry: 24.805,
    transform: "matrix(1.16533 0 0 1.15783 -3.956 51.93)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.158,
    cy: -326.054,
    fill: "#feffff",
    className: "L",
    opacity: 0.9,
    rx: 6.63,
    ry: 24.805,
    transform: "matrix(1.16533 0 0 1.0707 -3.956 23.603)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.08488 0 0 .09222 -6.68 59.122)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.593,
    cy: -325.399,
    fill: "#05f0ff",
    filter: "url(#D)",
    opacity: 0.8,
    rx: 6.63,
    ry: 24.805,
    transform: "matrix(1.49929 0 0 1.30774 -75.689 99.471)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#06effe",
    filter: "url(#C)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.158,
    cy: -326.054,
    fill: "#fff",
    className: "K",
    opacity: 0.9,
    rx: 6.63,
    ry: 24.805,
    transform: "matrix(1.16533 0 0 1.15783 -3.956 51.93)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.158,
    cy: -326.054,
    fill: "#feffff",
    className: "L",
    opacity: 0.9,
    rx: 6.63,
    ry: 24.805,
    transform: "matrix(1.16533 0 0 1.0707 -3.956 23.603)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.09432,
    d: "M18.661 17.505h4.905l-.362 2.176h5.994l-.317-2.242 4.927.004 2.982 6.083-1.526 12.05H17.191l-1.513-12.05z",
    className: "I J"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.09432,
    d: "M36.74 23.526H15.665",
    className: "H",
    opacity: 0.343
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#444",
    transform: "matrix(.11536 0 0 .11536 -5.285 61.184)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.338-355.138v76.05h13.314v-29.184h20.237c5.326 0 9.692-.746 13.207-2.237 3.302-1.5 5.965-3.515 7.882-5.858 1.8-2.237 3.1-4.793 3.728-7.562s.96-5.22 1.065-7.67c0-2.343-.426-4.9-1.065-7.67s-1.917-5.326-3.728-7.67c-1.917-2.343-4.473-4.26-7.882-5.858-3.408-1.5-7.882-2.343-13.207-2.343zm13.314 36v-25.137h19.704c1.704 0 3.408.213 5.006.533 1.5.426 2.876 1.065 4.154 2.024 1.172.96 2.13 2.237 2.876 3.834.64 1.704.96 3.728 1.065 6.178 0 2.45-.426 4.473-1.278 6.07s-1.917 2.876-3.195 3.834-2.77 1.598-4.26 2.024c-1.598.426-3.1.64-4.58.64z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    x: 134.386
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.063-330.96h13.314c-.426-4.047-1.598-7.775-3.302-10.97-1.8-3.195-4.154-5.858-7.03-8.095s-6.178-3.94-9.905-5.113a40.61 40.61 0 0 0-12.036-1.8c-5.752 0-10.864 1.065-15.338 3.195s-8.308 5.006-11.397 8.627c-3.195 3.62-5.54 7.882-7.243 12.675-1.704 4.9-2.45 10.012-2.45 15.338 0 5.54.746 10.65 2.45 15.444 1.704 4.9 4.047 9.053 7.243 12.675 3.1 3.62 6.923 6.497 11.397 8.627s9.586 3.1 15.338 3.1c4.58 0 8.84-.746 12.675-2.237s7.136-3.515 10.012-6.284a32.02 32.02 0 0 0 6.71-9.799c1.704-3.728 2.663-7.882 2.982-12.462H745.5c-.32 2.77-.96 5.432-1.8 7.775-.96 2.45-2.237 4.58-3.834 6.4a19.26 19.26 0 0 1-5.858 4.26c-2.343 1.065-4.9 1.5-7.882 1.5-4.047 0-7.562-.746-10.545-2.45-2.982-1.598-5.326-3.728-7.136-6.497-1.917-2.77-3.302-5.858-4.154-9.373-.852-3.408-1.278-6.923-1.278-10.65-.107-3.515.426-7.136 1.278-10.65.852-3.408 2.237-6.497 4.154-9.266 1.8-2.77 4.154-4.9 7.136-6.604 2.982-1.598 6.4-2.343 10.545-2.45 2.663 0 5.113.426 7.243 1.172s3.94 1.8 5.54 3.1a20.815 20.815 0 0 1 3.834 4.793c.96 1.917 1.704 3.94 2.343 6.07zm25.313-24.178v76.05H783.7v-34.296h34.616v34.296h13.314v-76.05h-13.314v30.25H783.7v-30.25zm77.3 0v76.05h55.492v-11.503H860.98v-22.26h38.344v-10.864H860.98v-19.918h41.433v-11.503zm-308.92 116.546c-.677-2.894-1.805-5.467-3.384-7.825s-3.384-4.288-5.64-5.896c-2.256-1.5-4.624-2.68-7.33-3.538a27.1 27.1 0 0 0-8.346-1.286c-5.414 0-9.925.965-13.76 2.894s-6.993 4.502-9.474 7.718a31.38 31.38 0 0 0-5.414 10.72 45.8 45.8 0 0 0-1.692 12.328c0 4.181.564 8.254 1.692 12.328a30.93 30.93 0 0 0 5.414 10.827c2.482 3.217 5.64 5.68 9.474 7.6s8.346 2.894 13.76 2.894c3.722 0 7.106-.643 10.15-1.93 2.932-1.18 5.527-3.002 7.782-5.253 2.143-2.144 3.835-4.717 5.3-7.718a38.23 38.23 0 0 0 2.594-9.648h7.67c-.564 4.717-1.692 9.005-3.496 12.756-1.805 3.86-4.173 7.075-6.993 9.648-2.932 2.68-6.316 4.717-10.15 6.1-3.835 1.5-8.12 2.144-12.858 2.144-6.316 0-11.955-1.072-16.693-3.216s-8.685-5.145-11.843-8.8-5.527-7.825-7.106-12.65c-1.58-4.717-2.37-9.755-2.37-15.115 0-5.253.8-10.3 2.37-15.115 1.58-4.717 3.948-9.005 7.106-12.65 3.045-3.645 7.106-6.646 11.843-8.8s10.376-3.216 16.693-3.323a39.01 39.01 0 0 1 11.166 1.608c3.6 1.072 6.993 2.68 9.925 4.824s5.414 4.717 7.444 7.718c2.03 3.1 3.27 6.646 3.835 10.613z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.332-225.407h28.648a23.22 23.22 0 0 0 6.654-.965c2.03-.643 3.835-1.715 5.527-3.002 1.466-1.286 2.82-2.787 3.722-4.6s1.353-3.966 1.466-6.325c0-4.6-1.466-8.36-4.286-11.148-2.932-2.68-7.218-3.966-13.083-4.073h-28.648zm-7.67-36.34h36.88a37.85 37.85 0 0 1 9.361 1.179c2.932.858 5.527 2.037 7.782 3.645s3.948 3.645 5.3 6.217 2.03 5.467 2.03 8.897c0 4.93-1.353 9.112-3.948 12.65-2.707 3.645-6.542 5.896-11.73 6.86v.214c2.594.43 4.737 1.072 6.542 2.037 1.692.965 3.045 2.144 4.173 3.645s1.917 3.323 2.37 5.253.8 4.073 1.015 6.325c0 1.286.113 2.894.226 4.717 0 1.93.226 3.752.45 5.68.113 1.93.564 3.645 1.015 5.36s1.128 3.002 2.03 3.86h-8.46a6.97 6.97 0 0 1-1.128-2.573c-.226-1.072-.45-2.144-.564-3.216s-.226-2.25-.226-3.323c-.113-1.072-.226-1.93-.226-2.787l-.8-8.04c-.338-2.68-1.015-5.038-2.143-7.182s-2.707-3.752-4.737-5.145c-2.03-1.18-4.85-1.822-8.46-1.715h-29.1v33.98h-7.67zm75.338.001h27.858c12.18.322 21.43 3.645 27.633 9.862s9.36 15.758 9.36 28.407c0 12.756-3.158 22.297-9.36 28.514s-15.452 9.54-27.633 9.755H718zm7.67 70.32h16.354c5.752 0 10.715-.536 14.888-1.715s7.67-3.1 10.376-5.68c2.594-2.573 4.624-5.896 5.978-9.97 1.24-4.073 1.805-8.897 1.917-14.686 0-5.68-.677-10.613-1.917-14.686-1.353-4.073-3.27-7.397-5.978-9.97s-6.203-4.395-10.376-5.574-9.136-1.822-14.888-1.822H725.67z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M",
    x: 236.148
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.013-261.746h8.12l26.167 68.5h.226l25.94-68.5h8.12l-29.9 76.54h-8.9zm81 46.523h31.693l-15.565-39.234zm12.18-46.524h8.572l31.58 76.54H995.1l-9.812-23.798h-36.656l-9.7 23.798h-8.12z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApacheCordova);
export default __webpack_public_path__ + "static/media/apache_cordova.45da420cc013122f0052a451e49bc2fb.svg";
export { ForwardRef as ReactComponent };